import { captureError } from '@smg-real-estate/browser-rum';

const reportedErrors = new WeakSet<object>();

/**
 * Reports an error to RUM at most once per error instance.
 *
 * @remarks
 * An error is usually reported where it is thrown (e.g. `fetch.ts`) and then rethrown through
 * the API and store layers. Reporting it with this helper at every layer keeps a single failed
 * request down to a single RUM error, without the callers having to know who reported it first.
 */
export function captureErrorOnce(...args: Parameters<typeof captureError>) {
  const [error] = args;
  if (typeof error === 'object' && error !== null) {
    if (reportedErrors.has(error)) return;
    reportedErrors.add(error);
  }
  captureError(...args);
}
